export default "__VITE_ASSET__BBgfs0kK__"